import React from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import { DropShadowMedium } from '../DropShadows/DropShadowMedium';
import { EditMenuItem } from './EditMenuItem';
import { FlatList, View } from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';
import { concatPath } from '../../utils/links/concatPath';
import { contentStackKey, dashboardStackKey, exerciseKey, privateKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../hooks/useStores';

export type EditMenuExerciseProps = {
    exerciseId: string;
    completed: boolean;
    onDiscard: () => void;
    onClose: () => void;
}


const _EditMenuExercise = ({exerciseId, completed, onDiscard, onClose}: EditMenuExerciseProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.HOME;

  const items : EditMenuItem[]= [
    {
      label : labels?.VIEW_CHALLENGE,
      onPress: () => {
        // only closes the menu: onDiscard opens the stop/complete modal
        // ("Congratulations..."), which has nothing to do with viewing it
        onClose();
        router.navigate({
          pathname: concatPath([privateKey, dashboardStackKey, contentStackKey,exerciseKey ], -1) as string,
          params: {id: exerciseId}
        });
      }
    }
  ];
  if(!completed){
    items.push(  {
      label : labels?.STOP_CHALLENGE,
      onPress: onDiscard,
      color: COLORS.state.danger.primary
    });
  }

  return(
    <DropShadowMedium>
      <View style={{borderRadius: SPACING['sp-12'], overflow: 'hidden', backgroundColor: COLORS.surface['contrast']}}>
        <FlatList data={items}
          renderItem={({item}) => <EditMenuItem {...item} />}
          ItemSeparatorComponent={() => <View style={{height: 1, backgroundColor: COLORS.border.primary}} />}
        />
      </View>
    </DropShadowMedium>

  );

};

export const EditMenuExercise= observer(_EditMenuExercise);